@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="my-jobs-page" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <header>
        <div class="title">
            <lucide-angular name="circle-user-round" size="44"></lucide-angular>
            <h1>{{ 'nav.profile.title' | translate }}</h1>
        </div>
    </header>

    <div class="content">
        <div class="block">
            <h3>{{ 'common.account' | translate }}</h3>
            @let client= (client$ | async);
            <ul>
                <li>
                    <p class="label">{{ 'common.name' | translate | titlecase }}</p>
                    <p class="value">{{ client?.username }}</p>
                </li>
                <li>
                    <p class="label">{{ 'common.mail' | translate | titlecase }}</p>
                    <p class="value">{{ client?.email }}</p>
                    
                </li>
                <li>
                    <p class="label">{{ 'common.created_at' | translate | titlecase }}</p>
                    <p class="value">{{ client?.created_at | date:'short' }}</p>
                </li>
            </ul>
        </div>

        <div class="card">
            @let clientPlan = clientPlan$ | async;
            <h3>Plan:</h3>
            <p>{{ clientPlan?.name }} ( {{ clientTokenPerMonth$ | async}} tokens /month )</p>
            <p>Prochain renouvellement: {{ clientPlan?.endDate | date:'short' }}</p>
            <app-button routerLink="/dashboard/plans" type="discreet">{{'common.change_my_plan' | translate}}</app-button>
            @if(clientPlan && clientPlan.name !== 'Starter'){
                @let formatedEndDate = clientPlan.endDate | date:'short';
            <app-button (onClick)="openCancelPlanModal(formatedEndDate, clientPlan.tokensLeft)" type="discreet">{{('common.cancel_my_plan' | translate).replace('{planName}', clientPlan.name)}}</app-button>
            }
        </div>
        <app-languages-switcher></app-languages-switcher>
        <app-button (onClick)="openLogoutModal()">{{ 'auth.logout' | translate }}</app-button>
        <app-button type="danger" (onClick)="openDeleteAccountModal()">{{'common.delete_my_account' | translate}}</app-button>
    </div>
</div>